import {
  useEffect,
  useState,
  type InputEvent,
  type InputHTMLAttributes,
} from "react";
import "./currency-input-field.css";

type CurrencyInputProps = InputHTMLAttributes<HTMLInputElement> & {
  currencyCode?: string;
  symbol?: string;
};

export function CurrencyInput({
  currencyCode = "EUR",
  symbol,
  value,
  defaultValue,
  onInput,
  ...inputProps
}: CurrencyInputProps) {
  const [visibleValue, setVisibleValue] = useState(
    String(value ?? defaultValue ?? ""),
  );
  const visibleSymbol = symbol ?? (currencyCode === "BRL" ? "R$" : "€");
  const prefix = currencyCode === "BRL" && symbol === undefined;

  useEffect(() => {
    if (value !== undefined) setVisibleValue(String(value));
  }, [value]);

  const handleInput = (event: InputEvent<HTMLInputElement>) => {
    setVisibleValue(event.currentTarget.value);
    onInput?.(event);
  };

  return (
    <span className={`currency-input-field ${prefix ? "is-prefix" : "is-suffix"}`}>
      <input
        {...inputProps}
        value={value}
        defaultValue={value === undefined ? defaultValue : undefined}
        onInput={handleInput}
      />
      {visibleValue.trim() && (
        <span className="currency-input-position" aria-hidden="true">
          {prefix && <span className="currency-input-symbol">{visibleSymbol}</span>}
          <span className="currency-input-mirror">{visibleValue}</span>
          {!prefix && <span className="currency-input-symbol">{visibleSymbol}</span>}
        </span>
      )}
    </span>
  );
}
